import { __decorate, __metadata } from "tslib";
import { Serialize } from '@ftr/serialization';
import { LineItem } from './LineItem';
import { Order } from './Order';
/**
 * A view of the Order tailored to what the customer who placed it is allowed to see
 */
export class CustomerOrder extends Order {
}
__decorate([
    Serialize(() => LineItem),
    __metadata("design:type", Object)
], CustomerOrder.prototype, "lineItem", void 0);
